import { AxiosResponse } from 'axios';

import { HttpService } from '~system/api/base/http-service';

import { ApiLoginResponse, ApiResetPasswordRequest } from '~shared/types';

export const resetPassword = async (
  resetPasswordData: ApiResetPasswordRequest
) => {
  const { data }: AxiosResponse<ApiLoginResponse> = await HttpService.post(
    'lessor/auth/password/verify-reset-token',
    resetPasswordData
  );

  return data;
};
